module.exports = __webpack_public_path__ + "static/media/aboutUs_27_31.47064277.jpg";